import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Typography, Box } from '@material-ui/core';
const useStyles = theme => ({
    root: {
        position: 'relative'
    }
});

class Footer extends Component {
    render() {
        const { classes } = this.props;
        return (
            <Grid className={classes.root}>
                <Box style={{ height: '370px', width: '100%', background: '#3f3f3f', marginTop: '-30px' }}>
                    <Grid style={{ display: 'flex', flexDirection: 'row' }}>
                        <Grid style={{ display: 'flex', flexDirection: 'column', marginTop: '30px' }}>
                            <Typography variant="subtitle1" style={{ display: 'flex', color: '#ffffff', fontSize: '1.1rem', marginLeft: '350px', fontWeight: 'bold' }} >
                                Who we serve
                            </Typography>
                            <Typography variant="subtitle1" style={{ display: 'flex', color: '#ffffff', fontSize: '0.9rem', marginLeft: '350px', marginTop: '10px' }} >
                                Rv Park Owners
                            </Typography>
                            <Typography variant="subtitle1" style={{ display: 'flex', color: '#ffffff', fontSize: '0.9rem', marginLeft: '350px', marginTop: '5px' }} >
                                Campground managers
                            </Typography>
                            <Typography variant="subtitle1" style={{ display: 'flex', color: '#ffffff', fontSize: '0.9rem', marginLeft: '350px', marginTop: '5px' }} >
                                Event Coordinators
                            </Typography>
                            <Typography variant="subtitle1" style={{ display: 'flex', color: '#ffffff', fontSize: '0.9rem', marginLeft: '350px', marginTop: '5px' }} >
                                Marina Owners
                            </Typography>
                            <Typography variant="subtitle1" style={{ display: 'flex', color: '#ffffff', fontSize: '0.9rem', marginLeft: '350px', marginTop: '5px' }} >
                                Glaming Resorts
                            </Typography>
                            <Typography variant="subtitle1" style={{ display: 'flex', color: '#ffffff', fontSize: '0.9rem', marginLeft: '350px', marginTop: '5px' }} >
                                Lodges & Cabins
                            </Typography>
                            <Typography variant="subtitle1" style={{ display: 'flex', color: '#ffffff', fontSize: '0.9rem', marginLeft: '350px', marginTop: '5px' }} >
                                Camping Clubs
                            </Typography>
                            <Typography variant="subtitle1" style={{ display: 'flex', color: '#ffffff', fontSize: '0.9rem', marginLeft: '350px', marginTop: '5px' }} >
                                Adventure Groups
                            </Typography>
                        </Grid>
                        <Grid style={{ display: 'flex', flexDirection: 'column', marginTop: '30px' }}>
                            <Typography variant="subtitle1" style={{ display: 'flex', color: '#ffffff', fontSize: '1.1rem', marginLeft: '50px', fontWeight: 'bold' }} >
                                <a href="https://opencampground.com/features/" target="_blank" style={{ textDecoration: 'none', color: '#ffffff' }}>
                                    Features
                                </a>
                            </Typography>
                            <Typography variant="subtitle1" style={{ display: 'flex', color: '#ffffff', fontSize: '0.9rem', marginLeft: '50px', marginTop: '10px' }} >
                                <a href="https://opencampground.com/about/" target="_blank" style={{ textDecoration: 'none', color: '#ffffff' }}>
                                    Why Open Campground
                                </a>
                            </Typography>
                            <Typography variant="subtitle1" style={{ display: 'flex', color: '#ffffff', fontSize: '0.9rem', marginLeft: '50px', marginTop: '10px' }} >
                                <a href="https://opencampground.com/about/" target="_blank" style={{ textDecoration: 'none', color: '#ffffff' }}>
                                    Pricing
                                </a>
                            </Typography>
                            <Typography variant="subtitle1" style={{ display: 'flex', color: '#ffffff', fontSize: '0.9rem', marginLeft: '50px', marginTop: '10px' }} >
                                <a href="https://opencampground.com/demo/" target="_blank" style={{ textDecoration: 'none', color: '#ffffff' }}>
                                    Demo
                                </a>
                            </Typography>
                            <Typography variant="subtitle1" style={{ display: 'flex', color: '#ffffff', fontSize: '0.9rem', marginLeft: '50px', marginTop: '10px' }} >

                                <a href="https://opencampground.com/resources/" target="_blank" style={{ textDecoration: 'none', color: '#ffffff' }}>
                                    Resources
                                </a>
                            </Typography>
                            <Typography variant="subtitle1" style={{ display: 'flex', color: '#ffffff', fontSize: '0.9rem', marginLeft: '50px', marginTop: '10px' }} >
                                <a href="https://opencampground.com/about/" target="_blank" style={{ textDecoration: 'none', color: '#ffffff' }}>
                                    Partners
                                </a>
                            </Typography>
                            <Typography variant="subtitle1" style={{ display: 'flex', color: '#ffffff', fontSize: '0.9rem', marginLeft: '50px', marginTop: '10px' }} >
                                <a href="https://opencampground.com/contact-us/" target="_blank" style={{ textDecoration: 'none', color: '#ffffff' }}>
                                    contact us
                                </a>
                            </Typography>
                        </Grid>
                        <Grid style={{ display: 'flex', flexDirection: 'column', marginTop: '30px' }}>
                            <Typography variant="subtitle1" style={{ display: 'flex', color: '#ffffff', fontSize: '1.1rem', marginLeft: '50px', fontWeight: 'bold' }} >
                                <a href="https://opencampground.com/privacy-policy/" target="_blank" style={{ textDecoration: 'none', color: '#ffffff' }}>
                                    Terms And Conditions
                                </a>
                            </Typography>
                            <Typography variant="subtitle1" style={{ display: 'flex', color: '#ffffff', fontSize: '0.9rem', marginLeft: '50px', marginTop: '10px' }} >
                                Privacy Policy
                            </Typography>
                            <Typography variant="subtitle1" style={{ display: 'flex', color: '#ffffff', fontSize: '0.9rem', marginLeft: '50px', marginTop: '5px' }} >
                                EULA
                            </Typography>
                        </Grid>
                        <Grid style={{ display: 'flex', flexDirection: 'column', marginTop: '30px' }}>
                            <Typography variant="subtitle1" style={{ display: 'flex', color: '#ffffff', fontSize: '1.1rem', marginLeft: '50px', fontWeight: 'bold' }} >
                                <a href="https://opencampground.com/contact-us/" target="_blank" style={{ textDecoration: 'none', color: '#ffffff' }}>
                                    contact us
                                </a>
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid style={{ marginTop: '30px' }}>
                        <Typography variant="caption" style={{ color: '#ffffff', fontWeight: 'bold' }}>
                            OpenCampgrounds, Copyright, All rights Reserved
                        </Typography>
                    </Grid>
                </Box>
            </Grid>
        );
    };
};

export default withStyles(useStyles)(Footer);